import * as previewApi from '@/api/preview';

export default {
    namespaced: true,
    state: {
        previewUrl: '',
        title: '',
    },
    getters: {
        previewUrl: state => state.previewUrl,
        title: state => state.title,
    },
    mutations: {
        setPreviewUrl(state, payload) {
            state.previewUrl = payload;
        },
        setTitle(state, payload) {
            state.title = payload;
        },
        clearPreview(state) {
            state.title = '';
            state.previewUrl = '';
        },
    },
    actions: {
        async fetchPreviewUrl({ commit, dispatch }, payload) {
            const response = await previewApi.getPreviewUrl(payload);

            // eslint-disable-next-line camelcase
            const { preview_url } = response.data.data;

            commit('setPreviewUrl', preview_url);
            commit('setTitle', payload.title);
        },
    },
};
